import { render, staticRenderFns } from "./ITStartup_3.vue?vue&type=template&id=454f2582&"
import script from "./ITStartup_3.vue?vue&type=script&lang=js&"
export * from "./ITStartup_3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports